<template>
  <div>
    <h2>热门文章</h2>
    <ul>
      <li v-for="(rank,index) in topTenList" class="rank_item" :key="index" @click="viewNews(rank.newsId)">
        <el-row>
          <el-col :span="3">
            <span v-if="index<4" class="topThree">{{index+1}}</span>
            <span v-if="index>3" class="topOther">{{index+1}}</span>
          </el-col>
          <el-col :span="21">
            <div class="rank-title-tiptext">{{rank.newsTitle}}</div>
          </el-col>
        </el-row>
      </li>
    </ul>
  </div>
</template>
<script>
import { topTen } from '@/api/frontApi/frontNews';
export default {
  props: {
    newsType: Number
  },
  data() {
    return {
      topTenList: []
    };
  },
  created() {
    this.topTenNews();
  },
  methods: {
    topTenNews() {
      topTen({ newsType: this.newsType, keywords: '' }).then(res => {
        this.topTenList = res.data;
      });
    },
    viewNews(newsId) {
      this.$router.push({
        name: 'knowInfo',
        params: { knowledgeId: newsId }
      });
    }
  }
};
</script>
<style lang="stylus" scoped>
.rank_item {
  line-height: 40px;
  height: 40px;
  font-size: 16px;
  margin-left: -15%;
  border: 1px solid #E4E7ED;
  margin-bottom: 10px;
  padding: 0 10px;
}

.rank_item:hover {
  background-color: #DCDFE6;
  cursor: pointer;
}

.topThree {
  padding: 3px 5px;
  border: 1px solid #f56c6c;
  color: #fff;
  background-color: #f56c6c;
  border-radius: 3px;
}

.topOther {
  padding: 3px 5px;
  border: 1px solid #8a8a8a;
  color: #8a8a8a;
  background-color: #fff;
  border-radius: 3px;
}
</style>



// WEBPACK FOOTER //
// src/pages/views/knowledge/topNews.vue